import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { ButtonBase, InputBase } from "../../../common/components/form";
import { useReduxAccount } from "../../hooks";
import * as API from "../../lib/api";
import * as Links from "../../lib/links";

export default function HelpPage() {
    const { t } = useTranslation();
    const history = useHistory();

    const { helptimer } = useReduxAccount();
    const allowHelp = helptimer < Date.now();

    const [helpMessage, setHelpMessage] = React.useState({
        subject: null,
        helpMessage: null,
    });
    const [errors, setErrors] = React.useState({});

    function onChange(event) {
        let { name, value } = event.target;

        const _errors = { ...errors };

        switch (name) {
            case "subject":
                if (!value || !value.trim()) {
                    _errors[name] = "ErrorFieldRequiredField";
                } else {
                    _errors[name] = null;
                }

                setHelpMessage({ ...helpMessage, [name]: value });

                break;

            case "helpMessage":
                _errors[name] = null;

                if (!value || !value.trim()) {
                    _errors[name] = "ErrorFieldRequiredField";
                }

                setHelpMessage({ ...helpMessage, [name]: value });

                break;
        }

        setErrors(_errors);
    }

    function errorByField(fieldname) {
        return errors[fieldname] ? t(errors[fieldname]) : null;
    }

    function onSendClick() {
        API.HelpMessageSend(helpMessage).then(r => {
            window.location.reload();
        });
    }

    const allowSend =
        Object.values(errors).filter(v => v).length === 0 &&
        (() => {
            for (const [key, value] of Object.entries(helpMessage)) {
                if (!value) {
                    return false;
                }
            }

            return true;
        })();

    return (
        <div className="panel-help">
            {allowHelp && (
                <div className="panel-help-content">
                    <h2 className="panel-heading-text">{t("NeedHelp")}</h2>

                    <div className="panel-help-fields">
                        <div className="panel-help-fields-item">
                            <InputBase name="subject" onChange={onChange} placeholder={t("Subject")} />
                            <p className="field-message color-error">{errorByField("subject") || <>&nbsp;</>}</p>
                        </div>

                        <div className="panel-help-fields-item">
                            <InputBase rows={4} name="helpMessage" onChange={onChange} placeholder={t("HelpMessage")} />
                            <p className="field-message color-error">{errorByField("helpMessage") || <>&nbsp;</>}</p>
                        </div>
                    </div>

                    <div className="panel-help-actions">
                        <ButtonBase solid onClick={() => history.push(Links.Dashboard())}>
                            {t("Cancel")}
                        </ButtonBase>

                        <ButtonBase invert onClick={() => onSendClick()} disabled={!allowSend}>
                            {t("Send")}
                        </ButtonBase>
                    </div>
                </div>
            )}

            {!allowHelp && (
                <div className="panel-help-content">
                    <h2 className="panel-heading-text">{t("RequestSent")}</h2>

                    <p className="panel-help-text">{t("RequestSentMessage")} </p>
                </div>
            )}
        </div>
    );
}
